import Vue from "vue";
import { trackGoogleEvent, trackFacebookEvent } from "@/mixins/eventTracking";
import { checkDateInput } from "@/mixins/checkDateInput";

Vue.mixin({
  methods: {
    trackGoogleEvent,
    trackFacebookEvent,
    checkDateInput,
  },
});
